import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import api, { formatApiError } from "../lib/api";

export default function RecuperarSenha() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-6" data-testid="recuperar-senha-page">
      <div className="grain-overlay" aria-hidden="true" />
      <div className="pointer-events-none fixed inset-0 bg-[radial-gradient(ellipse_at_50%_20%,rgba(212,175,55,0.08),transparent_55%)]" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md border border-gold/20 bg-[#0a0a0a]/90 p-10 backdrop-blur-xl"
      >
        <Link to="/entrar" className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 transition-colors hover:text-gold" data-testid="back-to-login-link">
          <ArrowLeft size={14} /> Voltar ao login
        </Link>
        <h1 className="mt-8 font-serif text-3xl text-zinc-100">Recuperar senha</h1>
        {sent ? (
          <div data-testid="forgot-success-message">
            <p className="mt-6 text-sm leading-relaxed text-zinc-400">
              Se este e-mail estiver cadastrado, você receberá um link para redefinir sua senha. O link é válido por 1 hora.
            </p>
            <p className="mt-8 text-center font-serif text-gold">✦</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 flex flex-col gap-5" data-testid="forgot-form">
            <p className="text-sm leading-relaxed text-zinc-400">
              Informe o e-mail da sua conta e enviaremos um link de redefinição.
            </p>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark" placeholder="Seu e-mail" data-testid="forgot-email-input" />
            {error && <p className="border border-red-900/50 bg-red-950/30 px-4 py-3 text-sm text-red-300" data-testid="forgot-error-message">{error}</p>}
            <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="forgot-submit-button">
              {loading ? "Enviando…" : "Enviar link de redefinição"}
            </button>
          </form>
        )}
      </motion.div>
    </div>
  );
}
